import { authenticatedDelete } from '../../../../../../api/request';

export default async function deleteServices(idService, setErrorMessage) {
    const onFail = () => setErrorMessage('Se produjo un error al eliminar el servicio.');
    const url = `/doctor-profile-management/doctor-services/${idService}`;
    return await authenticatedDelete(url, onFail);
}